import { jsx as r, jsxs as h } from "react/jsx-runtime";
import { useTranslation as ce, PaymentMethodEnum as me, getPaymentMethodTitle as ue, ContactSlugEnum as de, FieldErrorAndDescription as pe } from "@systemeio/ui";
import { useWatch as n } from "@systemeio/util";
import fe from "isomorphic-dompurify";
import { useState as T } from "react";
import he from "../../../components/layout.mjs";
import ge from "../../../components/store-image.mjs";
import Pe from "../../../components/affiliate-badge.mjs";
import ye from "../../../components/field.mjs";
import be from "../../../components/full-screen-card-wrapper.mjs";
import { PaymentMethodIcon as Ce } from "../../../components/payment-method-icon.mjs";
import { usePaymentProcessors as xe } from "../../../payment-processors/index.mjs";
import { usePhysicalProductStore as Me, useOfferStore as Ee } from "../../../store/index.mjs";
import { getDeepCopiedObject as Fe } from "../../../utils/get-deep-copied-object.mjs";
import { getDefaultFieldValues as Oe } from "../../../utils/get-default-field-values.mjs";
import { hasErrors as je } from "../../../utils/has-errors.mjs";
import { parseErrors as De } from "../../../utils/parse-errors.mjs";
import { offerDefaultErrors as C } from "../constants/default-errors.mjs";
import { useCatchCookiePurchaseError as Ie } from "../hooks/use-catch-cookie-purchase-error.mjs";
import { getDefaultCoverByProductType as Ne } from "../utils/get-default-cover-by-type.mjs";
import { getMissingFieldsErrors as Te } from "../utils/get-missing-fields-errors.mjs";
import { OrderSummary as ke } from "./components/order-summary/index.mjs";
import { ProductCard as ve } from "./components/product-card/index.mjs";
import { ShippingMethod as Se } from "./components/shipping-method/index.mjs";
import { getPhysicalProductPricePlan as k } from "./utils/get-physical-product-price-plan.mjs";
import _e from "../../../ui-kit/radio-group/radio-group-accordion.mjs";
const nt = (g) => {
  var I;
  const { title: x, description: v, buttonTitle: S, fields: _, cover: P, offerId: y, id: M } = g.checkoutPage, {
    currency: A,
    paymentMethods: L,
    thankYouPage: b,
    affiliateLink: R,
    displayAffiliateLink: q,
    productType: w,
    physicalProduct: o,
    shippingRules: B,
    calculatePrice: H,
    isLoadingShippingRules: W = !1,
    isLoadingCalculatePrice: U = !1,
    skipDisabledButton: $ = !1
  } = g, { t: l } = ce(), [z, G] = T(!1), [c, d] = T(C), { productVariant: m, quantity: V, selectedShipping: a } = Me();
  Ie({
    handlerError: (e) => d((t) => ({ ...t, common: [e] })),
    pagePath: g.checkoutPage.path
  });
  const {
    availablePaymentMethods: E,
    setAvailablePaymentMethods: J,
    setPaymentMethod: K,
    paymentMethod: p,
    setCurrency: Q,
    setPricePlan: F,
    setOfferId: X,
    setProductId: Y,
    finalAmount: Z,
    setFinalAmount: O,
    contactFields: s,
    setContactFields: j
  } = Ee();
  n(o == null ? void 0 : o.id, (e) => e && Y(e)), n(y, (e) => e && X(e)), n(L, (e) => e && J(e)), n(A, (e) => e && Q(e)), n(_, (e) => e && j(Oe(e))), n(o, (e) => {
    if (!e)
      F(void 0), O(void 0);
    else {
      const t = k(e, m);
      t && (F(t), O(t.amount));
    }
  });
  const ee = () => {
    let e = !1;
    const t = Fe(C);
    return Object.values(s).forEach(({ slug: i, value: u, required: f }) => {
      f && (u == null || u === "") && (t.customer.fields[i] = [l("public_pages_purchase.required-field")], e = !0);
    }), p || (t.paymentMethod = [l("public_pages_purchase.required-field")], e = !0), { errors: t, isFailed: e };
  }, D = !!Z && !!p && !!y && !!o && !!M, te = () => {
    if (!D) return;
    const e = k(o, m);
    if (!e) return;
    const t = Object.values(s).reduce((f, N) => (f[N.slug] = N.value ?? "", f), {}), i = `${window.location.origin}${(b == null ? void 0 : b.path) ?? ""}`, u = window.location.href;
    return {
      page: M,
      customer: {
        fields: t
      },
      offer: y,
      digitalProduct: null,
      pricePlan: e.id,
      purchaseProductModel: {
        product: o.id,
        productVariant: (m == null ? void 0 : m.id) ?? null,
        quantity: V,
        shippingRule: (a == null ? void 0 : a.ruleId) ?? null,
        shippingCondition: (a == null ? void 0 : a.conditionId) ?? null
      },
      thankYouPageUrl: i,
      failedReturnUrl: u,
      paymentMethod: p
    };
  }, re = () => {
    const { errors: e, isFailed: t } = ee();
    if (t) {
      d((i) => ({ ...i, ...e }));
      return;
    }
    return te();
  }, oe = (e) => {
    const t = De(e, C), i = Te(t.customer.fields, s);
    d({
      ...t,
      common: t.common.concat(i)
    });
  }, { paymentProcessorPaymentButton: se, paymentProcessorDetails: ie, PaymentProcessorProvider: ae } = xe({
    isFetching: z,
    setIsFetching: G,
    handleBadRequest: oe,
    buttonTitle: S,
    buttonDisabled: !D && !$,
    preSubmit: re,
    setErrors: d,
    hasErrors: je(c)
  }), ne = Object.values(E).filter((e) => e !== me.stripe_applepay).map((e) => ({
    id: e,
    caption: l(ue(e, l)),
    content: ie,
    additionalInfo: /* @__PURE__ */ r(Ce, { paymentMethod: e })
  })), le = (e, t) => {
    j({
      ...s,
      [e.slug]: { ...e, value: t }
    });
  };
  return /* @__PURE__ */ r(he, { children: /* @__PURE__ */ h(be, { children: [
    /* @__PURE__ */ h("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5 ", children: [
      /* @__PURE__ */ r(
        ge,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          src: P == null ? void 0 : P.path,
          imageType: Ne(w),
          alt: x
        }
      ),
      /* @__PURE__ */ r("h2", { className: "text-xl font-bold sm:text-3xl", children: x }),
      /* @__PURE__ */ h("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
        /* @__PURE__ */ r(
          "div",
          {
            className: "ckeditor-default text-sm sm:text-base sm:leading-5",
            dangerouslySetInnerHTML: {
              __html: fe.sanitize(v)
            }
          }
        ),
        o && /* @__PURE__ */ r(ve, { product: o }),
        s[de.Country] && /* @__PURE__ */ r(Se, { shipping: B, isLoading: W }),
        o && /* @__PURE__ */ r(
          ke,
          {
            product: o,
            calculatePrice: H,
            isLoading: U
          }
        ),
        Object.values(s).map((e) => /* @__PURE__ */ r(
          ye,
          {
            contactFields: s,
            field: e,
            value: s[e.slug].value,
            error: c.customer.fields[e.slug],
            onChange: (t) => le(e, t)
          },
          e.slug
        )),
        /* @__PURE__ */ h(ae, { children: [
          E.length > 0 && /* @__PURE__ */ r(
            _e,
            {
              label: l("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: ne,
              selected: p,
              onChange: (e) => K(e),
              required: !0,
              error: (I = c.paymentMethod) == null ? void 0 : I.join(", ")
            }
          ),
          c.common && /* @__PURE__ */ r(
            pe,
            {
              error: c.common.join(", "),
              errorClassName: "flex justify-center"
            }
          ),
          se
        ] })
      ] })
    ] }),
    q && /* @__PURE__ */ r(Pe, { affiliateLink: R })
  ] }) });
};
export {
  nt as PhysicalCheckout,
  k as getPhysicalProductPricePlan
};
